import { render, staticRenderFns } from "./DeleteOpportunityLabelDialog.vue?vue&type=template&id=26190b71"
import script from "./DeleteOpportunityLabelDialog.vue?vue&type=script&lang=js"
export * from "./DeleteOpportunityLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteOpportunityLabelDialog.vue?vue&type=style&index=0&id=26190b71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports